import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { AllocationViewEndpoint } from '../constants/allocation-view-endpoint';
import { AllocationViewListSearchCriteria } from '../models';
import { AllocationCalendarDock } from '../models/allocation-view-calendar';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewCalendarService {
  constructor(private http: WrapperHttpService) {}

  getAllocationViewCalendar({
    hubId,
    ...filters
  }: AllocationViewListSearchCriteria): Observable<AllocationCalendarDock[]> {
    const url = `${API_URL}${AllocationViewEndpoint.Calendar}/${hubId}${AllocationViewEndpoint.Slots}`;
    return this.http.withLoading().post<AllocationCalendarDock[]>(url, { filters });
  }
}
